module.exports = __webpack_public_path__ + "img/03.bd972b07.jpg";